import React, { memo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ProtectBar from './ProtectBar';
import Header from './Header';

const Layout = memo(function Layout() {
  const location = useLocation();
  const isSignupPage = location.pathname === '/signup';
  const isLoginPage = location.pathname === '/login';
  const isForgotPasswordPage = location.pathname === '/forgot-password';
  const isPaymentSuccessPage = location.pathname === '/success';
  const isCheckoutPage =
    location.pathname === '/checkout' ||
    location.pathname === '/checkout/v2';
  const hideProtectBar = isSignupPage || isLoginPage || isForgotPasswordPage || isPaymentSuccessPage || isCheckoutPage;
  
  return (
    <div className={`wrapper ${!hideProtectBar ? 'has-protect-bar' : ''}`}>
      {!hideProtectBar && <ProtectBar />}
      {!isCheckoutPage && <Header />}
      <Outlet />
    </div>
  );
});

export default Layout;
